import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ApproverGroup} from '../types'

export const ApproverGroupsQueryKey = 'approver-groups'

export const useApproverGroups = (
  {plantId}: {plantId: string},
  options?: Omit<UseQueryOptions<ApproverGroup[], AxiosError>, 'queryKey'>
) => {
  return useQuery<ApproverGroup[], AxiosError>({
    queryKey: [ApproverGroupsQueryKey, plantId],
    queryFn: async ({signal}) => {
      const path = `/shifthandover/${plantId}/system-change-requests/approver-groups`
      const response = await ApiClient.axiosInstance.get<ApproverGroup[]>(path, {signal})
      return response.data
    },
    ...options
  })
}
